export default "__VITE_ASSET__DXfsqR6A__"